<template>
  <div class="FacilityCode" :style="proMode ? 'background-color:rgb(33,33,33)' : 'white'">
    <!-- <CodeTable /> -->
    <SimpleEditor v-if="facRoute == 'WMH' || facRoute == 'HFM_Test' || facRoute == 'WMH_PRO_TEST' || facRoute == 'Test_Fac' || facRoute == 'Test_Pro' || facRoute == 'Test_Tech'" />
    <EnhancedEditor v-else />
  </div>
</template>

<script>
// @ is an alias to /src
// import CodeTable from '@/components/CodeTable.vue';
import SimpleEditor from '@/components/SimpleEditor.vue';
import EnhancedEditor from '@/components/EnhancedEditor.vue';
import { mapGetters } from "vuex";

export default {
  name: 'FacilityCode',
  components: {
    //CodeTable,
    SimpleEditor,
    EnhancedEditor
  },
  computed: {
        ...mapGetters(["userprof","proMode","facSettings"]),
        facRoute(){
          return (this.$route.params && this.$route.params.facilityName ? this.$route.params.facilityName : null);
        }
  },
  mounted(){
    this.countdownToExport();
  },
  methods:{
    countdownToExport(){
      
    },
  }
}
</script>
